import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber, IsEnum } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { OperationTypeEnum } from '@gtpl/shared-models/common-models';

export class LotInfoRequest {
    @ApiProperty()
    @IsNotEmpty()
    lotNumber: string;


    @ApiProperty()
    @IsNotEmpty()
    saleOrderId?: number;

    @ApiProperty()
    @IsNotEmpty()
    saleOrderItemId?: number;

    @ApiProperty()
    @IsOptional()
    plantId: number;

    // @ApiProperty()
    // @IsOptional()
    // saleOrderItemId?: number;
    @ApiProperty({
        enum: OperationTypeEnum
    })
    @IsEnum(OperationTypeEnum)
    presentOperation: OperationTypeEnum;

   
}